import { render } from "./CustomExample.vue?vue&type=template&id=7d34c9d0"
import script from "./CustomExample.vue?vue&type=script&lang=ts"
export * from "./CustomExample.vue?vue&type=script&lang=ts"
script.render = render

export default script